import type { PublicSlotKey } from '@/apilib';
import type { ImageToBackgroundPublicApi } from './api';

export const ImageToBackgroundApiKey: PublicSlotKey<ImageToBackgroundPublicApi> =
  {
    name: 'ImageToBackgroundPackageApi',
    public: true,
  };
